import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DatePipe } from '@angular/common'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {DashboardModule} from './dashboard/dashboard.module';
import {AdminModule} from './admin/admin.module';
import {ReportModule} from './report/report.module';

import{SharedModule} from './shared/shared.module';
import { SharedRoutingModule } from './shared/shared-routing.module';


import {AuthModule} from './auth/auth.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxMaskModule, IConfig } from 'ngx-mask'


//prime-ng
import {TableModule} from 'primeng/table';
import {ToastModule} from 'primeng/toast';
import {CalendarModule} from 'primeng/calendar';
import {SliderModule} from 'primeng/slider';
import {MultiSelectModule} from 'primeng/multiselect';
import {ContextMenuModule} from 'primeng/contextmenu';
import {DialogModule} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {DropdownModule} from 'primeng/dropdown';
import {ProgressBarModule} from 'primeng/progressbar';
import {InputTextModule} from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import {MenubarModule} from 'primeng/menubar';
import {MessagesModule} from 'primeng/messages';
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { CardModule } from 'primeng/card';
import { PanelModule } from "primeng/panel";
// import { FormsModule } from "@angular/forms";
import {InputSwitchModule} from 'primeng/inputswitch';
import {CheckboxModule} from 'primeng/checkbox';
import {TabViewModule} from 'primeng/tabview';
import {FileUploadModule} from 'primeng/fileupload';
import { ChartsModule,ThemeService } from 'ng2-charts';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import {EditorModule} from 'primeng/editor';

import { PathLocationStrategy, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { DragDropModule } from 'primeng/dragdrop';
import { DocViewerModule } from './doc-viewer/doc-viewer.module';
import {VendorOnboardingModule} from './vendor-onboarding/vendor-onboarding.module';




@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    // FormsModule,
    AppRoutingModule,
    SharedModule,
    DashboardModule,
    AuthModule,
    AdminModule,
    ReportModule,

    BrowserAnimationsModule,
    NgxSpinnerModule,
    ChartsModule,
    TableModule,
    CalendarModule,
		SliderModule,
		DialogModule,
		MultiSelectModule,
		ContextMenuModule,
		DropdownModule,
		ButtonModule,
		ToastModule,
    InputTextModule,
    ProgressBarModule,
    MenuModule,
    MenubarModule,
    CardModule,
    PanelModule,
    TabViewModule,
    InputSwitchModule,
    CheckboxModule,
    MessagesModule,
    FileUploadModule,
    ConfirmPopupModule,
    DynamicDialogModule,
    NgxMaskModule.forRoot(),
    EditorModule,
    PdfViewerModule,
    ModalModule,
    DragDropModule,
    DocViewerModule,
    VendorOnboardingModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    , {provide: LocationStrategy, useClass: PathLocationStrategy}
    , DatePipe,BsModalService
  ],
  exports: [NgxSpinnerModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }  
